<button class="btn__solid action-btn {{ additionalClass }}" [class.small]="small" [matMenuTriggerFor]="menu">
  <i class="icon icon-Arrow_carret_ico action-btn__icon"></i>

  <mat-menu class="no-mat-menu-styles" #menu="matMenu" yPosition="below" xPosition="before">
    <div class="action-item" (click)="click()" data-cy="create-subproject-btn">
      <i class="icon icon-Project_ico mr-1"></i>
      <span>{{ 'Create Subproject' | translate }}</span>
    </div>
  </mat-menu>
</button>
